import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FORMLY_CONFIG, FormlyModule } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { formValidationConfig } from './messages';
import { isValidEmail } from './validators/email';
import { isValidVietnamesePhoneNumber } from './validators/phoneNumber';
import { passwordMatchValidator } from './validators/repeatPassword';
import { noSpacesNoSpecialCharacters } from './validators/noSpacesNoSpecial';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule.forChild({
      validators: [
        { name: 'email', validation: isValidEmail },
        {
          name: 'phoneNumber',
          validation: isValidVietnamesePhoneNumber,
        },
        {
          name: 'passwordMatch',
          options: { errorPath: 'confirmPassword' },
          validation: passwordMatchValidator,
        },
        {
          name: 'noSpacesNoSpecial',
          validation: noSpacesNoSpecialCharacters,
        },
      ],
    }),
  ],
  providers: [
    {
      provide: FORMLY_CONFIG,
      multi: true,
      useFactory: formValidationConfig,
      deps: [TranslateService],
    },
  ],
})
export class ValidationModule {}
